import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Temporarily disable smooth scrolling
    const originalBodyStyle = document.body.style.scrollBehavior;
    const originalHtmlStyle = document.documentElement.style.scrollBehavior;
    
    document.body.style.scrollBehavior = 'auto';
    document.documentElement.style.scrollBehavior = 'auto';

    // Perform the scroll
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE

    // If you have a scrollable div/container
    const scrollContainer = document.querySelector(".scrollable-container");
    if (scrollContainer) {
      const originalContainerStyle = scrollContainer.style.scrollBehavior;
      scrollContainer.style.scrollBehavior = 'auto';
      scrollContainer.scrollTop = 0;
      
      // Restore the original scroll behavior for the container
      requestAnimationFrame(() => {
        scrollContainer.style.scrollBehavior = originalContainerStyle;
      });
    }

    // Restore the original scroll behavior
    requestAnimationFrame(() => {
      document.body.style.scrollBehavior = originalBodyStyle;
      document.documentElement.style.scrollBehavior = originalHtmlStyle;
    });
  }, [pathname]);

  return null;
}